import { Card, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import { SettingContext } from "../../routes";
import { formatDate } from "../../services/util";
import { UserDeleteOutlined } from "@ant-design/icons";

function CallsAnsweredDetails() {
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const { id } = useParams();
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);

    const { selectedDates, kioskSelection } = useContext(SettingContext);

    const [start_date, end_date] = selectedDates;

    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "accepted_calls_counts",
    });
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        page: 0,
        limit: 10,
        hotel_ids: [id],
        call_type: kioskSelection,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
        // all_selected: hotel_ids.length > 0 ? false : true,
    });

    const {
        status: callsAnsweredStatus,
        data: callsAnsweredRes,
        refetch: fetchCallsAnsweredDetails,
    } = useQuery(
        `CallsAnswered${id}`,
        async () => {
            return await HTTP("/dashboard/getAcceptedCallsDetailsForHotel", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchCallsAnsweredDetails();
    }, []);

    useEffect(() => {
        fetchCallsAnsweredDetails();
    }, [formData]);

    useEffect(() => {
        setFormData({
            ...formData,
            call_type: kioskSelection,
        });
    }, [kioskSelection]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        if (callsAnsweredStatus === "success") {
            const { data: callAnsweredData, total } = callsAnsweredRes;
            setTotalRecords(total);
            setTableData(callAnsweredData);
        }
    }, [callsAnsweredStatus, callsAnsweredRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }
        const updatedFormData = { ...formData, ...others };
        setFormData(updatedFormData);
    }

    const columns = [
        {
            title: "Staff Name",
            render: (_, record) => (
                <div style={{ display: "flex", alignItems: "baseline" }}>
                    <p className="margin-right-5">
                        {record?.first_name !== "" && record?.last_name !== ""
                            ? `${record.first_name} ${record.last_name}`
                            : "-"}
                    </p>
                    {record?.is_deleted ? (
                        <UserDeleteOutlined style={{ color: "#F43F5E" }} />
                    ) : (
                        ""
                    )}
                </div>
            ),
        },
        {
            title: "Calls Accepted",
            dataIndex: "accepted_calls_counts",
            key: "accepted_calls_counts",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "accepted_calls_counts"
                    ? sortedInfo.order
                    : null,
        },
    ];

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            {callsAnsweredStatus === "loading" ||
            callsAnsweredStatus === "idle" ? (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 20, width: 40 }}
                />
            ) : (
                <CustomTable
                    columns={columns}
                    tableData={tableData}
                    noOfrecords={totalRecords}
                    handleTableChange={handleTableChange}
                    rowKey="hotel_id"
                />
            )}
        </Card>
    );
}
export { CallsAnsweredDetails };
